<template>
  <skeleton v-if="loading && !keepAlive" />
  <tab-bar-layout v-else
                  class="page-course-home"
  >
    <course-layout>

      <header-block :search="render.search"
                    :show-vip-entrance="render.showVipCenter"
                    :show-playing-btn="render.showPlayingBtn"
                    :banner="banner"
                    record-type="course"
                    @click-banner="handleClickBanner"
      >
        <div v-if="colleges.length > 0"
             class="college-list"
        >
          <router-link class="college-item"
                       v-for="item in colleges"
                       :key="item.id"
                       :to="item.url"
                       v-ym-report:COURSE_MAIN_ENTRY_CLICK="item"
          >
            <ym-img class="college-icon"
                    :src="item.src"
                    :alt="item.name"
            />
            <span v-if="item.name !== ''"
                  class="college-name"
                  v-html="item.name"
            ></span>
          </router-link>
        </div>
      </header-block>

      <welfare-btn v-if="render.welfare && render.welfare.show"
                   :show="render.welfare.show"
                   :src="render.welfare.src"
                   :url="render.welfare.url"
                   :width="welfareWidth"
      />

      <product-list :main-block="mainBlock"
                    empty-string="暂无课程"
                    record-type="course"
      />
    </course-layout>
  </tab-bar-layout>
</template>

<script>
  import Skeleton from '@/skeleton/CourseIndex';
  import CourseLayout from '@/pages/Course/Layout';
  import TabBarLayout from '@/layout/TabBarLayout';
  import HeaderBlock from '@/components/HomeHeaderBlock';
  import ProductList from '@/components/Product/BlockList';
  import WelfareBtn from '@/pages/Audio/components/WelfareBtn';
  import { getCourseIndex } from '@/services/course';
  import { getMainBlockExplore } from '@/services/main-block';

  export default {
    name: 'PageCourse',
    metaInfo: {},
    components: {
      Skeleton,
      TabBarLayout,
      CourseLayout,
      HeaderBlock,
      ProductList,
      WelfareBtn,
    },
    data() {
      return {
        loading: false,
        keepAlive: false,

        banner: [],
        colleges: [],

        mainBlock: [],
        mainBlockStart: 0,
        mainBlockAllLoad: false,

        render: {
          pageTitle: '素质实践直播课',
          showVipCenter: false,
          search: null,
          welfare: {
            show: false,
            src: '',
            url: '',
            width: 160,
          },
        },
      };
    },
    computed: {
      welfareWidth() {
        const { welfare } = this.render;
        return welfare && welfare.width ? parseInt(welfare.width, 10) : 160;
      },
    },
    methods: {
      async getCourseIndex() {
        this.loading = true;

        const data = await getCourseIndex();

        this.banner = data.banner;
        this.colleges = data.colleges;

        this.render = data.render;

        this.loading = false;
        this.keepAlive = true;
      },
      async getCourseMainBlock() {
        if (this.mainBlockAllLoad) return;

        const params = {
          tab: 'course_index',
          start: this.mainBlockStart,
        };
        const data = await getMainBlockExplore(params);

        const { length: totalLength } = data;

        const { length } = data.list;
        if (length === 0) {
          this.mainBlockAllLoad = true;
        }

        this.mainBlock.splice(totalLength, length, ...data.list);
        this.mainBlockStart = data.start;

        this.getCourseMainBlock();
      },
      fetchData() {
        this.getCourseIndex();
        // 重置mainBLock 拉取数据
        this.mainBlockAllLoad = false;
        this.mainBlockStart = 0;
        this.mainBlock = [];
        this.getCourseMainBlock();
      },
      handleClickBanner(item) {
        this.$router.push(item.url);
      },
    },
    activated() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @college-padding-size: 35px;
  @college-item-size: 120px;

  .college-list {
    padding: @size-extra-medium @college-padding-size @size-extra-small;
    display: flex;
    justify-content: space-between;
    text-align: center;
    color: @color-text-light;
    font-size: @font-size-small;
  }

  .college-item {
    flex-shrink: 0;
    width: @college-item-size;
  }

  .college-icon {
    display: block;
  }

</style>
